import React, { useState } from "react";
import { Segment, Form } from "@/components/bp/bp-ui";
import { CaseRunCreate } from "./CaseRunCreate";
import { CaseClient } from "@app/api2/api";
import { buildUrl, AppRoutes } from "../AppRoutes";
import { useLabs } from "../Hooks/UseLabs";
import { PageHeader } from "@common/PageHeader";
import { insertComponentsIntoText } from "@common/Utils";
import { BPButton } from "@/components/bp/bpbutton";
import { BPContainer } from "@/components/bp/bpcontainer";


export const CaseRunCreateWithLabCaseSelect: React.FC<{ runType: string, baseUrl: string }> = ({ runType, baseUrl }) => {
    // const [selectedLab, setSelectedLab] = useState<number | null>(null);
    const [selectedCase, setSelectedCase] = useState<number | null>(null);
    const [showForm, setShowForm] = useState(false);
    const caseClient = new CaseClient();

    const labs = useLabs({})

    const handleStart = async () => {
        if (labs.selectedId) {
            let daily = await caseClient.createDaily(labs.selectedId)
            let url = buildUrl(AppRoutes.CaseRunCreateWithLabSelect, {
                runType: runType
            });
            setSelectedCase(daily.caseId);
            // location.assign(url);
            setShowForm(true);
        }
    };

    return (
        <BPContainer>
            {!showForm ? (

                <BPContainer>
                    <Form>
                        <PageHeader
                            header={insertComponentsIntoText(window.translation.caseRunView.newRun, { '{caseName}': '' })}
                        />
                        <Segment basic>
                            <p>
                                Please select a lab to create a new case run.
                            </p>
                            {labs.renderCombo()}

                        </Segment>
                        {/* <Segment> */}
                        {/* </Segment> */}
                        <Segment basic>
                            <BPButton
                                primary
                                onClick={handleStart}
                                disabled={!labs.selectedId}>
                                Select
                            </BPButton>
                        </Segment>
                    </Form>

                </BPContainer>
            ) : (
                <CaseRunCreate runType={runType} labId={labs.selectedId} caseId={selectedCase} aic={false} />
            )}
        </BPContainer>
    );
};

